<template>
    <div class="card">
        <div class="p-2 text-center bg-dark" v-if="resource.isImage">
            <b-img :src="resource.url | image('glance')" class="img-thumbnail" blank-color="#777" style="max-height:300px;" :alt="resource.name" v-if="resource.isImage" />
        </div>
        <div class="card-header bg-dark" v-if="resource.resourceType == 'file'">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" :class="{'active': tab == 'details'}" href="#" @click.prevent="changeTab('details')">{{ $t('[[[Szczegóły]]]') }}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" :class="{'active': tab == 'description'}" href="#" @click.prevent="changeTab('description')">{{ $t('[[[Opisy]]]') }}</a>
                </li>
            </ul>
        </div>
        <div class="card-body pb-0" v-if="tab == 'details'">
            <h5 class="card-title mb-4">{{ resource.name }}</h5>
            <h6 class="card-subtitle mt-1 mb-1">{{ $t('[[[Utworzył]]]') }}</h6>
            <ul class="list-unstyled">
                <li><i class="fas fa-user"></i> {{ resource.createdBy }}</li>
                <li><i class="fas fa-clock"></i> {{ resource.dateCreatedUtc | datetime }}</li>
            </ul>
            <h6 class="card-subtitle mt-1 mb-1">{{ $t('[[[Zmodyfikował]]]') }}</h6>
            <ul class="list-unstyled">
                <li><i class="fas fa-user"></i> {{ resource.modifiedBy }}</li>
                <li><i class="fas fa-clock"></i> {{ resource.dateModifiedUtc | datetime }}</li>
            </ul>
            <div v-if="resource.resourceType == 'file'">
                <h6 class="card-subtitle mt-1 mb-1">{{ $t('[[[Typ mime]]]') }}</h6>
                <ul class="list-unstyled">
                    <li><i class="fas fa-file"></i> {{ resource.contentType }}</li>
                </ul>
                <h6 class="card-subtitle mt-1 mb-1">{{ $t('[[[Rozmiar]]]') }}</h6>
                <ul class="list-unstyled">
                    <li><i class="fas fa-hdd"></i> {{ resource.contentLength | filesize }}</li>
                </ul>
                <div v-if="resource.isImage">
                    <h6 class="card-subtitle mt-1 mb-1">{{ $t('[[[Wymiary]]]') }}</h6>
                    <ul class="list-unstyled">
                        <li><i class="fas fa-arrows-alt"></i> {{ `${resource.meta.width}x${resource.meta.height} px` }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="card-body p-2" v-if="tab == 'description'">
            <b-form-group :label="$t('[[[Wybrany język]]]')">
                <b-form-select v-model="language" :options="languages" />
            </b-form-group>
            <div v-for="lang in languages" :key="lang.value" v-if="lang.value === language">
                <b-form-group :label="$t('[[[Nazwa]]]')">
                    <b-form-input v-model="content[lang.value].name" :key="resource.id" type="text"></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('[[[Opis]]]')">
                    <textarea class="form-control" v-model="content[lang.value].lead" :key="resource.id"></textarea>
                </b-form-group>
                <b-form-group :label="$t('[[[Tekst alternatywny]]]')">
                    <b-form-input v-model="content[lang.value].alt" type="text" :key="resource.id"></b-form-input>
                </b-form-group>
            </div>
            <hr>
            <div class="d-flex">
                <b-button type="submit" variant="primary" :disabled="processing" @click.prevent="saveContent()">
                    <i class="fas fa-check"></i> {{ $t('[[[Zapisz]]]') }}
                </b-button>
                <div class="text-danger small pl-2">{{ $t('[[[Wszystkie niezapisane zmiany zostaną utracone.]]]') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import StorageService from '@/services/core/StorageService';

export default {
    name: 'filemanager-resource',
    props: {
        'resource': {
            type: Object
        },
        'languages': {
            type: Array,
            required: true
        }
    },
    data()
    {
        return {
            tab: 'details',
            processing: false,
            language: null,
            content: {}
        };
    },
    created()
    {
        this.updateLanguage();
        this.updateContent();
    },
    methods: {
        changeTab(name)
        {
            this.tab = name;
        },
        updateLanguage()
        {
            this.language = this.languages.length > 0 ? this.languages[0].value : null;
        },
        updateContent()
        {
            this.content = this.resource.content || {};

            for (let i = 0; i < this.languages.length; i++)
            {
                let lang = this.languages[i].value;
                this.content[lang] = this.content[lang] || {};
            }
        },
        async saveContent()
        {
            try
            {
                this.processing = true;

                await StorageService.saveContent(this.resource.id, this.content);

                this.processing = false;
                this.$alert.success(this.$t('[[[Zamiany zostały zapisane.]]]'));
                this.$emit('reload');
            }
            catch (ex)
            {
                this.processing = false;

                if (ex.code === 400)
                {
                    this.$alert.warning(ex.message);
                }

                this.$log.debug(ex);
            }
        }
    },
    watch: {
        resource()
        {
            this.updateLanguage();
            this.updateContent();
        }
    }
};
</script>

<style lang="scss" scoped>
.nav-tabs {
    border-bottom: none;

    .nav-link {
        color: #ffffff;
        border-bottom-color: transparent;

        &.active {
            background-color: #ffffff;
            color: #000000;
        }
    }
}
</style>
